import React, { useState } from 'react';
import { api } from './api.js';
import styles from './AddManagerForm.module.css';

const AddManagerForm = ({ onSave, onClose }) => {
  const [nuevoEncargado, setNuevoEncargado] = useState({
    nombre: '',
    apellido: '',
    cedula: '',
    sexo: '',
    estadoCivil: '',
    fechaNacimiento: '',
    telefono: '',
    telefonoSecundario: '',
    direccion: '',
    provincia: '',
    municipio: '',
    sectorBarrio: '',
    correo: '',
    contraseña: '',
    rol: 'encargado_de_sector',
    nuevoSector: '',
    contactoEmergenciaNombre: '',
    contactoEmergenciaTelefono: '',
  });

  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [loading, setLoading] = useState(false);

  const handleMouseDown = (e) => {
    if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'SELECT') {
      setIsDragging(true);
      setOffset({ x: e.clientX, y: e.clientY });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      const dx = e.clientX - offset.x;
      const dy = e.clientY - offset.y;
      e.target.closest(`.${styles.addManagerForm}`).style.transform = `translate(${dx}px, ${dy}px)`;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNuevoEncargado((prevState) => ({
      ...prevState,
      [name]: value,
      // Auto-rellena nuevoSector cuando cambias sectorBarrio
      ...(name === 'sectorBarrio' && { nuevoSector: value })
    }));
  };

  const handleSave = async () => {
    const { nombre, apellido, cedula, sexo, estadoCivil, fechaNacimiento, telefono, telefonoSecundario, direccion, provincia, municipio, sectorBarrio, correo, contraseña, rol, nuevoSector, contactoEmergenciaNombre, contactoEmergenciaTelefono } = nuevoEncargado;
    if (!nombre || !apellido || !cedula || !sexo || !estadoCivil || !fechaNacimiento || !telefono || !direccion || !provincia || !municipio || !sectorBarrio || !correo || !contraseña || !nuevoSector || !contactoEmergenciaNombre || !contactoEmergenciaTelefono) {
      alert('Todos los campos son obligatorios');
      return;
    }

    if (contraseña.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      // 1. Crear el nuevo sector
      const sectorData = {
        nombre: nuevoSector,
        estado: 'activo'
      };
      const sectorResponse = await api.createSector(sectorData);
      const sectorId = sectorResponse?.id;

      if (!sectorId) {
        alert('Error al crear el sector');
        setLoading(false);
        return;
      }

      // 2. Crear el nuevo usuario (encargado de sector)
      const userData = {
        nombre,
        apellido,
        cedula,
        sexo,
        estadoCivil,
        fechaNacimiento,
        telefono,
        telefonoSecundario,
        direccion,
        provincia,
        municipio,
        sectorBarrio,
        email: correo,
        password: contraseña,
        rol,
        sectorId,
        estado: 'activo',
        contactoEmergenciaNombre,
        contactoEmergenciaTelefono
      };
      
      await api.createUser(userData);

      alert('Encargado y sector creados con éxito');
      setNuevoEncargado({
        nombre: '',
        apellido: '',
        cedula: '',
        sexo: '',
        estadoCivil: '',
        fechaNacimiento: '',
        telefono: '',
        telefonoSecundario: '',
        direccion: '',
        provincia: '',
        municipio: '',
        sectorBarrio: '',
        correo: '',
        contraseña: '',
        rol: 'encargado_de_sector',
        nuevoSector: '',
        contactoEmergenciaNombre: '',
        contactoEmergenciaTelefono: '',
      });

      if (onSave) onSave();
      if (onClose) onClose();
    } catch (error) {
      console.error('Error al crear encargado o sector:', error);
      alert(`Error: ${error.message || 'Ocurrió un error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    
    <div
    
      className={styles.addManagerForm}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <h3>Agregar Nuevo Encargado</h3>
      <div className={styles.scrollableContent}>
        <form>
        <div className={styles.formSection}>
          <h4 className={styles.sectionTitle}>Información Básica</h4>
          <div className={styles.twoColumns}>
            <label>
              Nombre:
              <input
                type="text"
                name="nombre"
                value={nuevoEncargado.nombre}
                onChange={handleInputChange}
                required
              />
            </label>

            <label>
              Apellido:
              <input
                type="text"
                name="apellido"
                value={nuevoEncargado.apellido}
                onChange={handleInputChange}
                required
              />
            </label>
          </div>

          <div className={styles.twoColumns}>
            <label>
              Cédula o Documento:
              <input
                type="text"
                name="cedula"
                value={nuevoEncargado.cedula}
                onChange={handleInputChange}
                placeholder="000-0000000-0"
                required
              />
            </label>

            <label>
              Sexo:
              <select
                name="sexo"
                value={nuevoEncargado.sexo}
                onChange={handleInputChange}
                required
              >
                <option value="">Seleccionar...</option>
                <option value="masculino">Masculino</option>
                <option value="femenino">Femenino</option>
                <option value="otro">Otro</option>
              </select>
            </label>
          </div>

          <div className={styles.twoColumns}>
            <label>
              Estado Civil:
              <select
                name="estadoCivil"
                value={nuevoEncargado.estadoCivil}
                onChange={handleInputChange}
                required
              >
                <option value="">Seleccionar...</option>
                <option value="soltero">Soltero/a</option>
                <option value="casado">Casado/a</option>
                <option value="divorciado">Divorciado/a</option>
                <option value="viudo">Viudo/a</option>
                <option value="union_libre">Unión Libre</option>
              </select>
            </label>

            <label>
              Fecha de Nacimiento:
              <input
                type="date"
                name="fechaNacimiento"
                value={nuevoEncargado.fechaNacimiento}
                onChange={handleInputChange}
                required
              />
            </label>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.sectionTitle}>Contacto</h4>
          <div className={styles.twoColumns}>
            <label>
              Teléfono:
              <input
                type="tel"
                name="telefono"
                value={nuevoEncargado.telefono}
                onChange={handleInputChange}
                placeholder="+1 (123) 456-7890"
                required
              />
            </label>

            <label>
              Teléfono Secundario (Opcional):
              <input
                type="tel"
                name="telefonoSecundario"
                value={nuevoEncargado.telefonoSecundario}
                onChange={handleInputChange}
                placeholder="+1 (123) 456-7890"
              />
            </label>
          </div>

          <div className={styles.twoColumns}>
            <label>
              Correo:
              <input
                type="email"
                name="correo"
                value={nuevoEncargado.correo}
                onChange={handleInputChange}
                required
              />
            </label>

            <label>
              Contraseña:
              <input
                type="password"
                name="contraseña"
                value={nuevoEncargado.contraseña}
                onChange={handleInputChange}
                required
              />
            </label>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.sectionTitle}>Contacto de Emergencia</h4>
          <div className={styles.twoColumns}>
            <label>
              Nombre del Contacto:
              <input
                type="text"
                name="contactoEmergenciaNombre"
                value={nuevoEncargado.contactoEmergenciaNombre}
                onChange={handleInputChange}
                placeholder="Nombre completo"
                required
              />
            </label>

            <label>
              Teléfono del Contacto:
              <input
                type="tel"
                name="contactoEmergenciaTelefono"
                value={nuevoEncargado.contactoEmergenciaTelefono}
                onChange={handleInputChange}
                placeholder="+1 (123) 456-7890"
                required
              />
            </label>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.sectionTitle}>Ubicación</h4>
          <label>
            Dirección:
            <input
              type="text"
              name="direccion"
              value={nuevoEncargado.direccion}
              onChange={handleInputChange}
              placeholder="Calle y número"
              required
            />
          </label>

          <div className={styles.threeColumns}>
            <label>
              Provincia:
              <input
                type="text"
                name="provincia"
                value={nuevoEncargado.provincia}
                onChange={handleInputChange}
                required
              />
            </label>

            <label>
              Municipio:
              <input
                type="text"
                name="municipio"
                value={nuevoEncargado.municipio}
                onChange={handleInputChange}
                required
              />
            </label>

            <label>
              Sector o Barrio:
              <input
                type="text"
                name="sectorBarrio"
                value={nuevoEncargado.sectorBarrio}
                onChange={handleInputChange}
                required
              />
            </label>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.sectionTitle}>Sector Asignado</h4>
          <label>
            Nombre del Nuevo Sector: <span style={{ color: 'red' }}>*</span>
            <input
              type="text"
              name="nuevoSector"
              value={nuevoEncargado.nuevoSector}
              onChange={handleInputChange}
              readOnly
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
              placeholder="Se rellenará automáticamente cuando ingreses el Sector o Barrio"
            />
          </label>

          <label style={{ marginTop: '10px' }}>
            Rol: <span style={{ color: 'red' }}>*</span>
            <select
              name="rol"
              value={nuevoEncargado.rol}
              onChange={handleInputChange}
              required
            >
              <option value="encargado_de_sector">Encargado de Sector</option>
              <option value="administrador">Administrador</option>
            </select>
          </label>
        </div>

        <div className={styles.formActions}>
          <button type="button" onClick={handleSave} disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
        </form>
      </div>
    </div>
  );
};

export default AddManagerForm;
